export const DASHBOARD_BASE_PATH = '/dashboard';

export const DASHBOARD_ROUTES = {
  dashboard: DASHBOARD_BASE_PATH,
};
